import { createSelector } from '@reduxjs/toolkit';
import { CapstoneInteragencyChatNotifications } from '../types/Organization';

/**
 * The slice of state this selector actually reads. Typing it this narrowly
 * rather than against the whole `StateWithSinatra` keeps the selector usable
 * from any store that carries sinatra, and testable without standing up a full
 * sinatra state.
 */
interface StateWithInteragencyChatNotifications {
  sinatra: {
    user?: {
      currentOrg?: {
        attributes?: {
          capstone?: {
            interagency_chat_notifications?: CapstoneInteragencyChatNotifications;
          };
        };
      };
    };
  };
}

/**
 * Agencies start with banners on, matching the sound default. An agency admin
 * opts out from Admin -> Notifications -> Agency Conversations.
 */
const defaultInteragencyChatNotifications: Required<CapstoneInteragencyChatNotifications> =
  {
    banner_on: true,
  };

const selectCapstoneOrgAttributes = (
  state: StateWithInteragencyChatNotifications,
) => state.sinatra.user?.currentOrg?.attributes?.capstone;

/**
 * Agency-level notification settings for interagency chat conversations. Stored
 * as a capstone org attribute, so orgs that have never touched the setting have
 * no key at all and fall back to the defaults above.
 */
export const selectInteragencyChatNotifications = createSelector(
  [selectCapstoneOrgAttributes],
  capstone => ({
    ...defaultInteragencyChatNotifications,
    ...capstone?.interagency_chat_notifications,
  }),
);

export const selectIsInteragencyChatBannerEnabled = createSelector(
  [selectInteragencyChatNotifications],
  settings => settings.banner_on,
);
